import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function RegisteredWithSuccess() {
  const navigate = useNavigate();

  const handleConfirmButton = () => {
    navigate('/login');
  };

  return (
    <main className="d-flex w-100 h-100 login-background">
      <div className="container d-flex flex-column">
        <div className="vh-100">
          <div className="mx-auto d-table h-100 w-50">
            <div className="d-table-cell align-middle">
              <Box className="mx-auto text-center mb-3">
                <img
                  className="img-fluid mb-4"
                  width="180"
                  height="48"
                  src="/img/logo.png"
                  alt="ビルドセルフ - BUILD-SELF"
                />
                <h2 className="text-bold my-2">
                  会員登録完了
                </h2>

                <Box className="card">
                  <Box className="card-body">
                    <Typography
                      textAlign="left"
                      fontSize={12}

                    >
                      会員のご登録ありがとうございます。ログインパスワードは大切に保管ください。 登録が完了しましたので、引き続きサービスをご利用ください。
                      <br />
                      <br />
                      また有料会員をご希望の方は、ログイン後アカウント管理のプラン設定からプラン変更にてご選択ください。
                      <br />
                      <br />
                    </Typography>

                    <Button
                      sx={{
                        fontSize: '0.8rem',
                      }}
                      onClick={handleConfirmButton}
                      variant="contained"
                    >
                      ログインする
                    </Button>
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default RegisteredWithSuccess;
